import LocationContract from '@/location/LocationContract';
import { LatLng } from 'leaflet';
import ImageContract from '@/image/ImageContract';
import LocationTheme from '@/location/LocationTheme';
import MarkerContract from '@/marker/MarkerContract';
import { NumberField, StringField } from 'vuex-orm-decorators';
import BodyContract from '@/marker/BodyContract';
import StudyContract from '@/study/StudyContract';

export default abstract class AbstractLocationDecorator implements LocationContract {
    protected origin: LocationContract;

    constructor(origin: LocationContract) {
        this.origin = origin;
    }

    public get id(): string {
        return this.origin.id;
    }

    public get image_active(): ImageContract {
        return this.origin.image_active;
    }

    public get image_inactive(): ImageContract {
        return this.origin.image_inactive;
    }

    public get map(): ImageContract {
        return this.origin.map;
    }

    public get markers(): Array<MarkerContract> {
        return this.origin.markers;
    }

    public get studies(): Array<StudyContract> {
        return this.origin.studies;
    }

    public get theme(): LocationTheme {
        return this.origin.theme;
    }

    public get title(): string {
        return this.origin.title;
    }

    @StringField()
    public about_campus!: BodyContract;

    latLng(): LatLng {
        return this.origin.latLng();
    }

    slug(): string {
        return this.origin.slug();
    }

    @NumberField()
    public weight!: number;
}
